import apiFetch from './apiFetch';

function buildRequestError(defaultMessage, status, data) {
  const error = new Error(data?.error || defaultMessage);
  error.status = status;
  error.data = data;
  return error;
}

async function parseResponseData(response) {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    return response.json();
  }

  const text = await response.text();
  return text ? { error: text } : null;
}

export async function fetchProfile() {
  const response = await apiFetch('/api/profile');
  const data = await parseResponseData(response);

  if (!response.ok) {
    throw buildRequestError('Failed to load profile.', response.status, data);
  }

  return data;
}

export async function updateProfile(payload) {
  const response = await apiFetch('/api/profile', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await parseResponseData(response);

  if (!response.ok) {
    throw buildRequestError('Failed to update profile.', response.status, data);
  }

  return data;
}

export async function changePassword({ currentPassword, newPassword }) {
  const response = await apiFetch('/api/profile/password', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ currentPassword, newPassword }),
  });

  if (!response.ok) {
    const data = await parseResponseData(response);
    throw buildRequestError('Failed to change password.', response.status, data);
  }
}
